export default {
    data() {
        return {
            basePath: global.BasePath,
            pagination: {
                pageSize: 10,
                pages: 0,
                total: 0,
                pageNo: 1,
            }
        }
    },
    filters: {
        timeSuffixFilter(datetime) {
            return datetime ? datetime.slice(0, datetime.indexOf('.')) : datetime;
        }
    },
    methods: {
        jumpToPage(path, query = {}, isReplace = false, isRefresh = false, refreshTimeout = 300) {
            if(isReplace) {
                this.$router.replace({
                    path,
                    query
                })
            } else {
                this.$router.push({
                    path,
                    query
                })
            }
            if(isRefresh) {
                setTimeout(() => {
                    window.location.reload();
                }, refreshTimeout);
            }
        },
        changeSize(pageSize) {
            this.pagination.pageNo = 1;
            this.pagination.pageSize = pageSize;
        },
        changeCurrent(pageNo) {
            this.pagination.pageNo = pageNo;
        },
        checkIndexPermission(permissionList, permissionPath) {
            return permissionList.indexOf(permissionPath) !== -1;
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/baseMixin.js